<template>
  <slot name="prepend" />

  <slot name="default">
    <AppLayoutDefaultView />
  </slot>

  <slot name="append" />
  <ToastNotifications />

  <Footer @update:is-version-info-shown="isVersionInfoShown = $event" />
</template>

<script lang="ts" setup>
  // import components
  import Footer from '@/components/Footer.vue';
  import AppLayoutDefaultView from '@/layouts/AppLayout/AppLayoutDefaultView.vue';
  import ToastNotifications from '@/components/ToastNotifications.vue';
  import { ref } from 'vue';

  const isVersionInfoShown = ref(false);
</script>
